/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import DisciplineSelect from '../DisciplineSelect';

const DisciplineField = ({ onChange, ...props }) => (
  <Form.Item {...props}>
    <DisciplineSelect onChange={onChange} />
  </Form.Item>
);

export default DisciplineField;
